import $ from 'jquery'
import React from 'react'
import { Component } from 'react'


class ZitatAuszugLoading extends Component {


    render() {

        return (
            <div className="grid-x">
                <div className="grid-x" style={{minWidth : "100%"}}>

                    <div className="small-8 large-8 cell grid-x">
                        <div className="small-12 large-12 cell mb">

                            <div className={"zitat-auszug grid-x placeholder-content mr"} id={"zitat-" + 0} >
                                <div className={"small-12 cell"}>
                                    <div>
                                        <div className={"text"}>
                                            <span className={"placeholder-content-item"}>...........................................</span>
                                        <br/>
                                        <span className={"placeholder-content-item"}>..............................</span>
                                        <br/>
                                            <span className={"placeholder-content-item"}>................................................................................</span>
                                        </div>
                                    </div>
                                    <div className={"shrink"}></div>
                                    <div className="quelle">
                                        <span className={"placeholder-content-item"}>.......</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="small-12 large-12 cell mb">

                            <div className={"zitat-auszug grid-x placeholder-content mr"} id={"zitat-" + 0} >
                                <div className={"small-12 cell"}>
                                    <div>
                                        <div className={"text"}>
                                            <span className={"placeholder-content-item"}>.....................</span>
                                        </div>
                                    </div>
                                    <div className={"shrink"}></div>
                                    <div className="quelle">
                                        <span className={"placeholder-content-item"}>.......</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="small-4 large-4 cell mb">

                        <div className={"zitat-auszug grid-x placeholder-content"} id={"zitat-" + 0} >
                            <div className={"small-12 cell"}>
                                <div>
                                    <div className={"text"}>
                                        <span className={"placeholder-content-item"}>.....................</span>
                                        <br/>
                                        <span className={"placeholder-content-item"}>..............................</span>
                                        <br/>
                                        <span className={"placeholder-content-item"}>..............................</span>
                                    </div>
                                </div>
                                <div className={"shrink"}></div>
                                <div className="quelle">
                                    <span className={"placeholder-content-item"}>.......</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="grid-x" style={{minWidth : "100%"}}>
                    <div className="small-6 large-6 cell">

                        <div className={"zitat-auszug grid-x placeholder-content mr"} id={"zitat-" + 0} >
                            <div className={"small-12 cell"}>
                                <div>
                                    <div className={"text"}>
                                        <span className={"placeholder-content-item"}>.....................</span>
                                        <br/>
                                        <span className={"placeholder-content-item"}>..............................</span>
                                    </div>
                                </div>
                                <div className={"shrink"}></div>
                                <div className="quelle">
                                    <span className={"placeholder-content-item"}>.......</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="small-6 large-6 cell">
                        <div className={"zitat-auszug grid-x placeholder-content"} id={"zitat-" + 0} >
                            <div className={"small-12 cell"}>
                                <div>
                                    <div className={"text"}>
                                        <span className={"placeholder-content-item"}>....................................................</span>
                                        <br/>
                                        <span className={"placeholder-content-item"}>..............................</span>
                                    </div>
                                </div>
                                <div className={"shrink"}></div>
                                <div className="quelle">
                                    <span className={"placeholder-content-item"}>.......</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default ZitatAuszugLoading


// WEBPACK FOOTER //
// ./cms_plugins/startseite_auszug/js/components/ZitatAuszugLoading.js